var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11535_44578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 8.33346H14.9993L9.99935 13.3335L4.99935 8.33346H9.16602V2.50012H10.8327V8.33346ZM3.33268 15.8335H16.666V10.0001H18.3327V16.6668C18.3327 16.8878 18.2449 17.0998 18.0886 17.256C17.9323 17.4123 17.7204 17.5001 17.4993 17.5001H2.49935C2.27834 17.5001 2.06637 17.4123 1.91009 17.256C1.75381 17.0998 1.66602 16.8878 1.66602 16.6668V10.0001H3.33268V15.8335Z",
    fill: "#1865C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11535_44578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.deeefd1278315bffe154301ec24bc455.svg";
export { ForwardRef as ReactComponent };